import { Directive, ElementRef, HostBinding, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[button-spacer], button-spacer, [buttonSpacer]',
    standalone: true,
    host: { class: 'button-spacer' },
})
export class ButtonSpacerDirective
{
    @Input() size: 'sm' | 'md' | 'lg' = 'md';

    @HostBinding('class.sm') get smallSpacer() {
        return this.size === 'sm';
    }

    @HostBinding('class.lg') get largeSpacer() {
        return this.size === 'lg';
    }
}

@Directive({
    selector: '[linkButton]',
    standalone: true,
    host: { class: 'link-button' },
})
export class ButtonDirective implements OnInit
{
    @Input() inlineLink?: HTMLSpanElement;

    constructor(private _renderer: Renderer2) {
    }

    @HostBinding('class.with-highlight') get inlineHighlightClass() {
        return !!this.inlineLink;
    }

    ngOnInit() {
        if (!!this.inlineLink) {
            this._renderer.addClass(this.inlineLink, 'link-highlight');
        }
    }
}

@Directive({
    selector: '[addAnotherButton]',
    standalone: true,
    host: { class: 'add-another-button' },
})
export class AddAnotherButtonDirective
{
}
